import { Action } from "@ngrx/store";

export const SET_CURRENT_TANK = "[TankManagement] SetCurrentTank";

export class SetCurrentTank implements Action {
  readonly type = SET_CURRENT_TANK;

  constructor(public currentTank: any) { }
}

export type Actions =
  | SetCurrentTank;
